module.exports = __webpack_public_path__ + "static/media/scaning.5c44fff2.png";